import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RESOLUTIONS } from 'services/config';
import Highcharts from 'highcharts/highstock';
import highcharts3d from 'highcharts/highcharts-3d';
highcharts3d(Highcharts);

class LineGraph extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
		};
	}
	getGraphSize() {
		const { breakpoint } = this.props;
		let width = 250;
		let height = 200;

		if (breakpoint === RESOLUTIONS.MED) {
			width = 350;
			height = 230;
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			width = 600;
			height = 300;
		}

		return { width, height };
	}

	createChart = () => {
		const { categories, title, yAxisLabel, stackOne, stackTwo, stackThree, id } = this.props;

		const { width, height } = this.getGraphSize();
		Highcharts.chart(`stacked-bar-graph-container ${id}`, {
			chart: {
				height,
				width,
				type: 'column',
			},
			legend: {
				enabled: false,
			},
			credits: {
				enabled: false,
			},

			title: {
				text: title,
			},

			xAxis: {
				categories,
			},

			yAxis: {
				allowDecimals: true,
				min: 0,
				title: {
					text: '',
				},
				labels: {
					format: yAxisLabel,
				},
			},

			tooltip: {
				formatter() {
					return (
						`<b>${this.x}</b><br/>` +
						`Copy` +
						`: ${this.y}<br/>` +
						`Total: ${this.point.stackTotal}`
					);
				},
			},

			plotOptions: {
				column: {
					stacking: 'normal',
				},
			},

			series: [
				{
					name: '',
					data: stackOne,
					stack: 'male',
				},
				{
					name: '',
					data: stackTwo,
					stack: 'male',
				},
				{
					name: '',
					data: stackThree,
					stack: 'male',
				},
			],
		});
	};

	componentDidMount() {
		this.createChart();
	}
	componentDidUpdate(prevProps) {
		const { stackOne, stackTwo, stackThree } = this.props;
		const stackOneString = stackOne.toString();
		const stackTwoString = stackTwo.toString();
		const stackThreeString = stackThree.toString();

		const s1s = prevProps.stackOne.toString();
		const s2s = prevProps.stackTwo.toString();
		const s3s = prevProps.stackThree.toString();
		if (stackOneString !== s1s || stackTwoString !== s2s || stackThreeString !== s3s) {
			this.createChart();
		}
	}

	render() {
		const { id } = this.props;

		return (
			<div
				id={`stacked-bar-graph-container ${id}`}
				className={`stacked-bar-graph-container ${id}`}
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
	};
}

export default connect(mapStateToProps, null)(LineGraph);
